<div style="page-break-inside: avoid;" *ngIf="nonAgriProperties[0]?.description || nonAgriPropertiesAdvance[0]?.description || agriProperties[0]?.description" class="mt-4" [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>PARTICULARS OF NON-AGRICULTURAL & AGRICULTURAL PROPERTIES</strong><br/>
            <i>[Attachment for serial no 8(d) & 8(e) of IT-10B (2023)]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
           <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div *ngIf="nonAgriProperties[0]?.description || nonAgriPropertiesAdvance[0]?.description" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Non-agricultural Properties
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Non-agricultural property at cost value or any advance made for such property (description, location and size)</td>
                        <td class="text-center">Purchase/Acquisition cost at the start of the income year</td>
                        <td class="text-center">Increased/ decreased during the income year</td>
                        <td class="text-center">Purchase/Acquisition cost at the end of the income year</td>
                    </tr>
                    <ng-container *ngIf="nonAgriProperties[0]?.description">
                        <tr *ngFor="let item of nonAgriProperties; let i = index">
                            <td class="text-center">{{i+1}}</td>
                            <td class="text-start">{{item?.description}} ({{item?.otherInfo}} {{item?.name}})</td>
                            <td class="text-right pr-3">{{item?.startYrAmount | currencySeparatorBD}}</td>
                            <td class="text-right pr-3">{{(item?.endYrAmount - item?.startYrAmount) | currencySeparatorBD}}</td>
                            <td class="text-right pr-3">{{item?.endYrAmount | currencySeparatorBD}}</td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="nonAgriPropertiesAdvance[0]?.description">
                        <tr *ngFor="let item of nonAgriPropertiesAdvance; let i = index">
                            <td class="text-center">{{(nonAgriProperties[0]?.description ? nonAgriProperties?.length : 0) + i + 1}}</td>
                            <td class="text-start">{{item?.description}}</td>
                            <td class="text-right pr-3">{{item?.startYrAmount | currencySeparatorBD}}</td>
                            <td class="text-right pr-3">{{(item?.endYrAmount - item?.startYrAmount) | currencySeparatorBD}}</td>
                            <td class="text-right pr-3">{{item?.endYrAmount | currencySeparatorBD}}</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="agriProperties[0]?.description" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Agricultural Properties
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Agricultural property at cost value (description, location and size)</td>
                        <td class="text-center">Purchase/Acquisition cost at the start of the income year</td>
                        <td class="text-center">Increased/ decreased during the income year</td>
                        <td class="text-center">Purchase/Acquisition cost at the end of the income year</td>
                    </tr>
                    <tr *ngFor="let item of agriProperties; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.description}} ({{item?.otherInfo}} {{item?.name}})</td>
                        <td class="text-right pr-3">{{item?.startYrAmount | currencySeparatorBD}}</td>
                        <td class="text-right pr-3">{{(item?.endYrAmount - item?.startYrAmount) | currencySeparatorBD}}</td>
                        <td class="text-right pr-3">{{item?.endYrAmount | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
